import { render } from "./AddF5LoadBalancer.vue?vue&type=template&id=18cf0d1d"
import script from "./AddF5LoadBalancer.vue?vue&type=script&lang=js"
export * from "./AddF5LoadBalancer.vue?vue&type=script&lang=js"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__